// PeekActivitySurface.jsx

import React from 'react';

// CSS
import './PeekActivitySurface.css';

// Components
import IconButton from 'components/iconbutton/IconButton';
import NodeActivityFeed from 'node/activity/NodeActivityFeed';

/**
 * PeekActivitySurface
 *
 * Hosts the blended Node Activity feed for Peek tab and right-rail placements.
 *
 * @param {object|null} node - The peeked node.
 * @param {boolean} [showHeader=false] - Whether to render a local Activity header.
 * @param {function} [onCollapse] - Optional hide-rail control for the workspace rail.
 * @returns {ReactNode}
 */
const PeekActivitySurface = React.memo(({
  node,
  showHeader = false,
  onCollapse,
}) => {
  if (!node) return null;

  const showCollapse = typeof onCollapse === 'function';

  return (
    <div className="peek-activity-surface-container">
      {showHeader ? (
        <div className="peek-activity-surface-header">

          {/* TITLE */}
          <div className="peek-activity-surface-title">
            Activity
          </div>

          {/* COLLAPSE */}
          {showCollapse ? (
            <IconButton
              iconKey="dock_to_right"
              title="Hide Activity"
              size={28}
              iconSize={18}
              onClick={onCollapse}
            />
          ) : null}
        </div>
      ) : null}

      <div className="peek-activity-surface-body">
        <NodeActivityFeed node={node} />
      </div>
    </div>
  );
});

PeekActivitySurface.displayName = 'PeekActivitySurface';

export default PeekActivitySurface;
